module.exports = __webpack_public_path__ + "img/home-s3-img1.a6fd9252.svg";